var React = require('react');

function PicIncludedin1 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-1{stroke:#008aae;}.cls-2{stroke:#ffe382;}")),React.createElement("title",{"key":1},"Zasób 30"),React.createElement("g",{"id":"Warstwa_2","data-name":"Warstwa 2","key":2},React.createElement("g",{"id":"Warstwa_4","data-name":"Warstwa 4"},[React.createElement("rect",{"className":"cls-1","x":"11.99","y":"-10.99","width":"42.14","height":"65.12","rx":"6.25","ry":"6.25","transform":"translate(54.63 -11.49) rotate(90)","key":0}),React.createElement("polygon",{"className":"cls-2","points":"26.38 21.21 26.38 11.78 34.55 16.49 42.72 21.21 34.55 25.93 26.38 30.64 26.38 21.21","key":1})]))]);
}

PicIncludedin1.defaultProps = {"viewBox":"0 0 66.12 43.14"};

module.exports = PicIncludedin1;

PicIncludedin1.default = PicIncludedin1;
